import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import type { BannerSlot, BannerSuggestion } from '@core/tellent-assistant-types';
import { injectTellentIntelligenceHttp } from '@core/tellent-http-legacy';

@Injectable({ providedIn: 'root' })
export class TellentAssistantHttp {
  private readonly httpApi = injectTellentIntelligenceHttp();

  public fetchSuggestions(slot: BannerSlot): Observable<readonly BannerSuggestion[]> {
    const body = { slot: slot.slot, params: 'params' in slot ? slot.params : {} };
    return this.httpApi
      .post('/tellent-assistant/suggestions', null, body)
      .pipe(map((response): readonly BannerSuggestion[] => response.data));
  }

  public recordEngagement(id: string): Observable<void> {
    return this.httpApi
      .post('/tellent-assistant/engagements', null, { id })
      .pipe(map(() => undefined));
  }
}
